import styles from "./Footer.module.css";

function Footer() {
  return (
    <div className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.label}>Josh Steede</div>
        <p>Built with React and shaped by work across web, games, and AI.</p>
      </div>
    </div>
  );
}

export default Footer;
